import React from 'react';
import { Route, Switch } from 'react-router';
import AboutUs from './pages/aboutUs';
import Contact from './pages/contact';
import Jobs from './pages/jobs';
import JobsDetail from './pages/jobsDetail';
import NotFound404 from './pages/notFound404';

export default function AppRoute() {
  return (
    <Switch>
      <Route exact path="/">
        <Jobs />
      </Route>
      <Route exact path="/jobs/:slug">
        <JobsDetail />
      </Route>
      <Route exact path="/about-us">
        <AboutUs />
      </Route>
      <Route exact path="/contact">
        <Contact />
      </Route>
      <Route>
        <NotFound404 />
      </Route>
    </Switch>
  );
}
